import React, { ReactNode } from 'react'

import { Collapse as CollapseMUI } from '@mui/material'

import Box, { BoxProps } from 'app/components/base/Box'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'

export interface TagsCollapseProps {
  title: ReactNode
  altTitle?: ReactNode
  sx?: BoxProps['sx']
  open?: boolean
  onClick: () => void
}

const TagsCollapse: RFC<TagsCollapseProps> = ({
  title,
  sx,
  open,
  children,
  altTitle,
  onClick
}) => {
  const buttonText = altTitle || title
  const titleNode = open ? buttonText : title

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', ...sx }}>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
          mb: 2,
          width: open ? 'auto' : 'max-content'
        }}
        onClick={onClick}
      >
        <Text variant="body2" sx={{ fontWeight: 500, ml: open ? 'auto' : 1 }}>
          {titleNode}
        </Text>
      </Stack>

      <CollapseMUI
        in={open}
        timeout="auto"
        unmountOnExit
        sx={{ display: open ? 'block' : 'none' }}
      >
        {children}
      </CollapseMUI>
    </Box>
  )
}

export default TagsCollapse
